define([
    'vue',
    'web/i18n/index',
    'WebCommon/mixin/page',
    'index2021-crest-line/component/page-content',

    // 'WebCommon/init'
], function(
    Vue,
    i18n,
    PageMixin,

    PageContent
){
    var app = new Vue({
        mixins: [PageMixin],
        components: {
            PageContent: PageContent
        },
        i18n: i18n
    });
    app.$mount('#app');

});


//////////////////
// WEBPACK FOOTER
// ./index2021-crest-line/main.js
// module id = 245
// module chunks = 10